export default __webpack_public_path__ + "pages/slides-6671480c192bbbff85da2ed501cdfe05.html";